
import { defineComponent } from 'vue'
import { getLocalization } from '@tokyojob/frontend-components'
import { getLayout } from '~/base/utils/bot/get.layout'
import { Layout } from '~/base/utils/constants/layout'
import { LocalizationPath } from '../../../../../../../../../core/src/models'
import { LocalizationService } from '../../../../../../../../core/src/modules'
import { getProvidedApp } from '~/base/utils/provided-getter'

export default defineComponent({
  layout: Layout.Home,
  props: {
    /**
     * Name of the html element in which the map should be displayed. Also used
     * as part of the name of the autocomplete field.
     */
    mapId: {
      required: true,
      type: String
    }
  },
  setup() {
    const localization = getLocalization(getProvidedApp())

    const instructionsStr = LocalizationService.t<string>(localization, LocalizationPath.mapSearchInstructions)
    return {
      instructionsStr
    }
  }
})
